import React from "react";

const holder = {
  closeTagRow(e) {
    if (
      holder.containerRef &&
      !holder.containerRef.current?.contains(e.target)
    ) {
      holder.internalStateSetter({
        isEditingName: false,
        isEditingColor: false,
        color: holder.tag?.color ?? "",
        value: holder.tag?.name ?? "",
      });
      document.removeEventListener("mousedown", holder.closeTagRow);
    }
  },
};

export default {
  "InputWithTextButton.Wrapper": ({ tag }, outlet) => {
    outlet({ selectedOption: tag, action: "tag-selected" });
  },
  "InputWithTextButton.Wrapper.Buttons.Color": async (
    { containerRef, tag },
    _,
    internalStateSetter
  ) => {
    internalStateSetter({ isEditingColor: true });
    let newContainerRef = containerRef;
    if (!newContainerRef) {
      newContainerRef = React.createRef({});
      await internalStateSetter({ containerRef: newContainerRef });
    }
    holder.containerRef = newContainerRef;
    holder.internalStateSetter = internalStateSetter;
    holder.tag = tag;
    document.addEventListener("mousedown", holder.closeTagRow);
  },
  "InputWithTextButton.Wrapper.Buttons.Name": async (
    { inputRef, containerRef, tag },
    outlet,
    internalStateSetter
  ) => {
    internalStateSetter({ isEditingName: true });
    let newInputRef = inputRef;
    let newContainerRef = containerRef;
    if (!newInputRef) {
      newInputRef = React.createRef({});
      await internalStateSetter({ inputRef: newInputRef });
    }
    if (!newContainerRef) {
      newContainerRef = React.createRef({});
      await internalStateSetter({ containerRef: newContainerRef });
    }
    newInputRef?.current?.children?.[0]?.focus?.();
    holder.containerRef = newContainerRef;
    holder.internalStateSetter = internalStateSetter;
    holder.tag = tag;
    document.addEventListener("mousedown", holder.closeTagRow);

    outlet({ action: "focused", tag: { ...tag } });
  },
  "InputWithTextButton.Wrapper.InputWrapper.TagInput": (
    { value, maxLength },
    _,
    internalStateSetter
  ) => {
    if (maxLength && value.length > maxLength) return;
    internalStateSetter({ value });
  },
  "InputWithTextButton.Wrapper.InputWrapper.TagInput(Keydown)": (
    { tagInputRef, value, maxLength, key, tag, color },
    outlet,
    internalStateSetter
  ) => {
    if (maxLength && value.length > maxLength) return;
    if (!value) return;
    if (key === "Enter") {
      if (tagInputRef?.current) {
        tagInputRef?.current?.children?.[0]?.children?.[0]?.focus?.();
      }

      outlet({ action: "change", tag: { ...tag, color: color, name: value } });
      internalStateSetter({
        value: "",
        isEditingName: false,
        isEditingColor: false,
      });
      document.removeEventListener("mousedown", holder.closeTagRow);
    }
  },
  "InputWithTextButton.Wrapper.Buttons.Delete": ({}, outlet) => {
    outlet({ action: "delete" });
  },
  "InputWithTextButton.Wrapper.ColorsWrapper.SaveButton": (
    { value, color, tag },
    outlet,
    internalStateSetter
  ) => {
    outlet({ action: "save", selectedOption: { ...tag, color: color, ...(value && {name: value}) } });
    internalStateSetter({ isEditingName: false, isEditingColor: false });
    document.removeEventListener("mousedown", holder.closeTagRow);
  },
  "InputWithTextButton.Wrapper.ColorsWrapper.TagColorSelect": (
    { tag, color, tagInputRef },
    outlet,
    internalStateSetter
  ) => {
    if (tagInputRef?.current) {
      tagInputRef?.current?.children?.[0]?.children?.[0]?.focus?.();
    }
    internalStateSetter({ color });
    outlet({ action: "focused", tag: { ...tag, color } });
  },
};
